import {Templates} from './Templates.js';

class Pretest extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates('Pretest');
		this.attachShadow({ mode: "open" });
		this.shadowRoot.appendChild(this.el);
	}
	connectedCallback() {
		const typ = this.getAttribute("test-type");
		if (typ) this.$.testType.innerText = typ;
		console.log(`Pretest.connectedCallback()`);
		const js = this.querySelector(`script[language="json"]`);
		console.log("Found js = ", js.innerText);
		if (!js) {
			console.error(`Please put a <script language="json"> tag inside the pretest element with details about the tests and the associated dates.`);
			return;
		}
		const data = JSON.parse(js.innerText);
		const now = new Date();
		const today = now.toISOString().split('T')[0];
		let link = false;
		for (const k of Object.keys(data)) {
			for (const d of data[k]) {
				if (d==today) {
					link = k;
					break;
				}
			}		
		}
		if (link) {
			console.log(`Found link ${link}`);
			this.$.link.setAttribute(`href`, link);
		} else {
			this.classList.add(`no-link`);
		}
	}
}

customElements.define('veedo-bbb-pretest', Pretest);